module.exports = __webpack_public_path__ + "static/daem-72f6f8152e7fd7e9fe3cfb7a62988b7d.jpeg";